import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

/**
 * Formata uma data do backend para exibição no frontend.
 * O wedrop-support API (Lucid/mysql2 timezone -03:00) retorna Dates como UTC real.
 * Basta parsear e formatar no timezone local do browser (BRT).
 */
export function formatMessageTime(dateString: string | Date): string {
  if (!dateString) return ''

  try {
    const date = dateString instanceof Date ? dateString : new Date(dateString)
    if (isNaN(date.getTime())) return ''
    return format(date, 'HH:mm', { locale: ptBR })
  } catch (error) {
    console.error('[DATE] Error formatting date:', dateString, error)
    return ''
  }
}

/**
 * Formata uma data do backend para exibição completa (data e hora).
 */
export function formatMessageDateTime(dateString: string | Date): string {
  if (!dateString) return ''

  try {
    const date = dateString instanceof Date ? dateString : new Date(dateString)
    if (isNaN(date.getTime())) return ''
    return format(date, 'dd/MM/yyyy HH:mm', { locale: ptBR })
  } catch (error) {
    console.error('[DATE] Error formatting datetime:', dateString, error)
    return ''
  }
}
